<div class="d-block">
  <div class="d-flex justify-content-end">
    <button class="inbound-filter-button btn btn-sm me-1" [class.active]="callType=='INBOUND'"
            (click)="callType=='INBOUND'?callType=null:callType='INBOUND'"><i
      class="fa fa-phone-flip"></i> {{ 'general.INBOUND' | translate }}
    </button>
    <button class="outbound-filter-button btn btn-sm me-1 active" [class.active]="callType=='OUTBOUND'"
            (click)="callType=='OUTBOUND'?callType=null:callType='OUTBOUND'"><i
      class="fa fa-phone"></i>  {{ 'general.OUTBOUND' | translate }}
    </button>
  </div>

  <div class="container">

    <div class="timeline">
      <div class="timeline-line"></div>

      <div *ngFor="let call of (calls | filterBy:'callType':callType)" class="timeline-item">
        <div class="timeline-dot" [ngClass]="call.callType=='INBOUND'?'green':'blue'"></div>

        <div class="call-card" [ngClass]="call.callType=='INBOUND'?'green':'blue'">
          <!-- Sol: Tarih, Kuyruk, Telefon -->
          <div class="call-section left-section">
            <div class="call-header d-flex">
              <i class="fa text-success" [class.fa-phone-flip]="call.callType=='INBOUND'"
                [class.fa-phone]="call.callType=='OUTBOUND'" [class.text-info]="call.callType=='OUTBOUND'"></i>
              <div class="d-flex-between">
                <div class="d-grid">
                  <span class="label">{{ 'case.call-informations.date' | translate }}</span>
                  <span class="label">{{ 'case.call-informations.caqueue' | translate }}</span>
                  <span class="label">{{ 'case.call-informations.phone' | translate }}</span>
                </div>
                <div class="d-grid">
                  <span class="infoText">{{ call.callStart | dateFormat:true }}</span>
                  <span class="infoText">#{{ call.id }} - {{ call.queue?.valueObject?.description?.value }}</span>
                  <span class="infoText">{{ call.phone }}
                    <app-call-button *ngIf="call?.phone" [class]="'btn btn-sm btn-success p-1 pb-0 pt-0'"
                      [phone]="call?.phone"></app-call-button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        
          <!-- Orta: Süre -->
          <div class="call-section middle-section">
            <div class="clock">
              <i class="fa-regular fa-clock"></i>
              <span>{{ call.callDuration }}'</span>
            </div>
          </div>
        
          <!-- Sağ: Sonlandırma, Sonuç Kodu, Kullanıcı -->
          <div class="call-section right-section">
            <div class="d-flex-between">
              <div class="d-grid">
                <span class="label">{{ 'case.call-informations.ending' | translate }}</span>
                <span class="label">{{ 'case.call-informations.result-code' | translate }}</span>
                <span class="label">{{ 'case.call-informations.user' | translate }}</span>
              </div>
              <div class="d-grid">
                <span class="infoText">{{ call.callEnd | dateFormat:true }}</span>
                <strong class="infoText">{{ call.card.status?.valueObject?.name?.value }}</strong>
                <span class="infoText">{{ call.user.firstName }} {{ call.user.lastName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <app-loading
    [fullScreen]="false"
    [loading]="loading ?? false"
  ></app-loading>
</div>

